export default __webpack_public_path__ + "static/media/overlay@2x.521dfc70.png";